import { LightShowOperation } from './lightshow-operation';
import { LightshowState } from '../lightshow-state';
import { FlashTypes } from '../operation-types';

const VIBRATE_SEGMENT_URL = 'https://lightshow-editor-sound-effects.s3.amazonaws.com/vibrate-iphone6.mp3';
export class VibrateOperation extends LightShowOperation {
  static cache = {};

  public audioUrl: string;
  public layerId: string;

  constructor(position: number,  layerId: string) {
    super();
    this.position = position;
    this.duration = 0.3;
    this.audioUrl = VIBRATE_SEGMENT_URL;
    this.layerId = layerId;
  }

  public end(state: LightshowState) {
    if (this.audioUrl) {
      state.RemoveAudioLayer(this.layerId);
    }
  }

  public tick(state: LightshowState) {
    if (this.audioUrl) {
      state.SetAudioLayer(this.layerId, this.audioUrl, state.playbackPosition - this.position);
    }
  }

  public toJson(allOperations: LightShowOperation[]) {
    return [
      { type: FlashTypes.vibrate, duration: this.duration, time: Math.round(this.position), url: this.audioUrl, volume: 1.0 } // play
    ];
  }

  public wait(state: LightshowState) {
    state.preloadAudio(this.audioUrl);
  }
}
